<div class="d-flex flex-column min-vh-100">
    <app-header-buscador></app-header-buscador>
    <br>
    <div class="container-lg container-md container-xl">
        <h2 class="titleAmpi">Consulta de valuación de terreno</h2>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="basicInput">Colonia</label>
                <div class="input-group input-group-merge round">
                    <ng-select [multiple]="true" [closeOnSelect]="false" class="custom" [items]="suburbsBasic"
                        bindLabel="fullName" bindValue="id" [(ngModel)]="suburbs">
                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                            <span class="ng-value-label"> {{ item.fullName }}</span>
                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-7 mb-1" style="height: 500px">
                <div id="map" class="sticky-top" style="position:fixed"></div>
            </div>
            <div class="col-md-5 mb-1" style="height: 500px">

                <ul ngbNav #nav="ngbNav" class="nav-tabs">
                    <li ngbNavItem>
                        <a ngbNavLink>Garita de Jalisco</a>
                        <ng-template ngbNavContent>
                            <h3 class="titleAmpi">Colonia consultada</h3>
                            <h1 class="text-primary priceAmpi">Garita de Jalisco</h1>
                            <br>
                            <h3 class="titleAmpi">Valor terreno m<sup>2</sup></h3>
                            <h1 class="text-primary priceAmpi">$15,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">Valor construcción m<sup>2</sup></h3>
                            <h1 class="text-primary priceAmpi">$25,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">GAP</h3>
                            <h1 class="text-primary priceAmpi">$10,000.00 MXN</h1>
                        </ng-template>
                    </li>
                    <li ngbNavItem>
                        <a ngbNavLink>Colinas del parque</a>
                        <ng-template ngbNavContent>
                            <h3 class="titleAmpi">Colonia consultada</h3>
                            <h1 class="text-primary1 priceAmpi">Colinas del parque</h1>
                            <br>
                            <h3 class="titleAmpi">Valor terreno m<sup>2</sup></h3>
                            <h1 class="text-primary1 priceAmpi">$25,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">Valor construcción m<sup>2</sup></h3>
                            <h1 class="text-primary1 priceAmpi">$50,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">GAP</h3>
                            <h1 class="text-primary1 priceAmpi">$25,000.00 MXN</h1>
                        </ng-template>
                    </li>
                    <li ngbNavItem>
                        <a ngbNavLink>Las lomas 1ra secc.</a>
                        <ng-template ngbNavContent>
                            <h3 class="titleAmpi">Colonia consultada</h3>
                            <h1 class="text-primary2 priceAmpi">Las lomas 1ra secc.</h1>
                            <br>
                            <h3 class="titleAmpi">Valor terreno m<sup>2</sup></h3>
                            <h1 class="text-primary2 priceAmpi">$20,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">Valor construcción m<sup>2</sup></h3>
                            <h1 class="text-primary2 priceAmpi">$35,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">GAP</h3>
                            <h1 class="text-primary2 priceAmpi">$15,000.00 MXN</h1>
                        </ng-template>
                    </li>
                    <li ngbNavItem>
                        <a ngbNavLink>Todos</a>
                        <ng-template ngbNavContent>
                            <h3 class="titleAmpi">Colonia consultada</h3>
                            <h1 class="text-primary3 priceAmpi">Zonas seleccionadas</h1>
                            <br>
                            <h3 class="titleAmpi">Valor terreno m<sup>2</sup></h3>
                            <h1 class="text-primary3 priceAmpi">$20,000.00 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">Valor construcción m<sup>2</sup></h3>
                            <h1 class="text-primary3 priceAmpi">$36,666.66 MXN</h1>
                            <br>
                            <h3 class="titleAmpi">GAP</h3>
                            <h1 class="text-primary3 priceAmpi">$16,666.66 MXN</h1>
                        </ng-template>
                    </li>
                </ul>

                <div [ngbNavOutlet]="nav" class="mt-2"></div>
            </div>
        </div>
    </div>
    <app-footer class="mt-auto"></app-footer>
</div>